type Props = { size?: number; color?: string };

export function Wordmark({ size = 30, color }: Props) {
  return (
    <span
      class="wordmark"
      style={{
        fontSize: `${size}px`,
        color: color ?? 'var(--ink)',
        display: 'inline-flex',
        alignItems: 'baseline',
      }}
    >
      shotmeal
      <span
        style={{
          display: 'inline-block',
          width: `${size * 0.13}px`,
          height: `${size * 0.13}px`,
          borderRadius: '50%',
          background: 'var(--gradient)',
          marginLeft: `${size * 0.06}px`,
          transform: `translateY(-${size * 0.05}px)`,
        }}
      />
    </span>
  );
}
